var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L20 0L20 20L0 20L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "history"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L20 0L20 20L0 20L0 0Z",
    id: "Background",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_91_",
    transform: "translate(1.5810547 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33355 9.67189L9.33355 10.4692L2.85684 10.4692L2.85684 9.09663L8.5115 9.09663C7.77701 8.48411 7.19265 7.69723 6.82244 6.80005L2.85684 6.80005L2.85684 5.42749L6.44265 5.42749C6.33141 4.68373 6.36188 3.91813 6.53436 3.18604L0 3.18604L0 20L12.1903 20L12.1903 10.4669C11.1513 10.4492 10.1769 10.1616 9.33355 9.67189L9.33355 9.67189ZM9.3334 17.7585L2.85669 17.7585L2.85669 16.386L9.3334 16.386L9.3334 17.7585ZM9.3334 14.0894L2.85669 14.0894L2.85669 12.7168L9.3334 12.7168L9.3334 14.0894Z",
    id: "XMLID_535_",
    fill: "#e12728",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2927 0C9.78665 0 7.7478 2.04004 7.7478 4.54761C7.7478 7.05521 9.78665 9.09526 12.2927 9.09526C14.7988 9.09526 16.8376 7.05521 16.8376 4.54761C16.8376 2.04004 14.7988 3.26043e-07 12.2927 3.26043e-07L12.2927 0ZM14.0775 6.21522L11.9846 5.16065C11.7532 5.04411 11.6073 4.80693 11.6073 4.54761L11.6073 0.908936L12.9778 0.908936L12.9778 4.12466L14.6934 4.98915L14.0775 6.21522Z",
    id: "XMLID_550_",
    fill: "#e12728",
    fillRule: "evenodd",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.b0e361cc700ebc425ccc294d1279fac1.svg";
export { ForwardRef as ReactComponent };